'use client'

import ctl from '@netlify/classnames-template-literals'
import { ReactNode, useContext } from 'react'
import { PresentationContext } from '../presentation-context'

export interface ListProps {
	children?: ReactNode
}

export function List({ children }: ListProps) {
	const presentation = useContext(PresentationContext)

	const looseClassName = ctl('gap-4 my-4')
	const tightClassName = ctl('my-1')

	const className = ctl(`
        list-disc flex flex-col
        ${presentation.spacing === 'loose' && looseClassName}
        ${presentation.spacing === 'tight' && tightClassName}
     `)

	return <ol className={className}>{children}</ol>
}

export interface ListItemProps {
	children?: ReactNode
}

List.Item = function ListItem({ children }: ListItemProps) {
	return <li className="ml-8">{children}</li>
}
